'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ga_IE = require('../locale/ga_IE');

var _ga_IE2 = _interopRequireDefault(_ga_IE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _ga_IE2['default'];